var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRevokedLottieIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    preserveAspectRatio: "xMidYMid meet",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)",
      contentVisibility: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "__lottie_element_368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    x: 0,
    y: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_368)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,50,50)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgb(245,79,78)",
    fillOpacity: 1,
    d: " M0,-21 C0,-21 0,-21 0,-21 C0,-21 0,-21 0,-21 C11.589900016784668,-21 21,-11.589900016784668 21,0 C21,0 21,0 21,0 C21,0 21,0 21,0 C21,11.589900016784668 11.589900016784668,21 0,21 C0,21 0,21 0,21 C-11.589900016784668,21 -21,11.589900016784668 -21,0 C-21,0 -21,0 -21,0 C-21,-11.589900016784668 -11.589900016784668,-21 0,-21 C0,-21 0,-21 0,-21"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    fillOpacity: 0,
    strokeMiterlimit: 4,
    stroke: "rgb(205,80,80)",
    strokeOpacity: 1,
    strokeWidth: 2,
    d: " M0,-21 C0,-21 0,-21 0,-21 C0,-21 0,-21 0,-21 C11.589900016784668,-21 21,-11.589900016784668 21,0 C21,0 21,0 21,0 C21,0 21,0 21,0 C21,11.589900016784668 11.589900016784668,21 0,21 C0,21 0,21 0,21 C-11.589900016784668,21 -21,11.589900016784668 -21,0 C-21,0 -21,0 -21,0 C-21,-11.589900016784668 -11.589900016784668,-21 0,-21 C0,-21 0,-21 0,-21"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,49.952999114990234,50)",
    opacity: 1,
    style: {
      display: "block"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fillOpacity: 0,
    stroke: "rgb(255,255,255)",
    strokeOpacity: 1,
    strokeWidth: 4,
    d: " M5.45,5.43 C2.64,2.63 -3.2,-3.18 -5.76,-5.73 M-5.427000045776367,5.445000171661377 C-2.634999990463257,2.6429998874664307 3.184999942779541,-3.197999954223633 5.732999801635742,-5.75600004196167"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    transform: "matrix(0,-1,1,0,0,0)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevokedLottieIcon);
export default __webpack_public_path__ + "static/media/revoked-lottie-icon.99e82a4479ab69fa5b1e7f82e5944961.svg";
export { ForwardRef as ReactComponent };